import { Components } from '../../../styles';
import { COLOR_DEFAULT, COLOR_PRIMARY, COLOR_SECONDARY } from './button';

export const fabTheme = {
  MuiFab: {
    styleOverrides: {
      root: {
        variants: [
          {
            props: { color: 'primary' },
            style: {
              ...COLOR_PRIMARY.contained,
              span: {
                // color is attached directly to icon styles. So we need to use !important to override it.
                color: COLOR_PRIMARY.contained.color + ' !important'
              }
            }
          },
          {
            props: { color: 'default' },
            style: COLOR_DEFAULT.contained
          },
          {
            props: { color: 'secondary' },
            style: {
              ...COLOR_SECONDARY.contained,
              span: {
                // color is attached directly to icon styles. So we need to use !important to override it.
                color: COLOR_SECONDARY.contained.color + ' !important'
              }
            }
          }
        ]
      }
    }
  }
} satisfies Components;
